import React from 'react'

export const Compass = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.00001 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.2273 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00888 0.153721 9.56073C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08602 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8.00001 0ZM11.096 6.38134L9.47734 9.47734L6.38134 11.096L3.28534 12.7147L4.904 9.61867L6.52267 6.52267L9.61867 4.904L12.7147 3.28533L11.096 6.38134Z'
      fill='white'
    />
  </svg>
)

export default Compass
